import { render, staticRenderFns } from "./fissionSpeed.vue?vue&type=template&id=bdff1abe&scoped=true"
import script from "./fissionSpeed.vue?vue&type=script&lang=js"
export * from "./fissionSpeed.vue?vue&type=script&lang=js"
import style0 from "./fissionSpeed.vue?vue&type=style&index=0&id=bdff1abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff1abe",
  null
  
)

export default component.exports